// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mission-card p{
    color: #000000;
}


.mission-cover {

    padding: 30px 30px;
    /* margin-top: 280px; */
    display: flex;text-align: center;

    flex-direction: column;



}

.mission-card {
    max-width: 100%;
    height: 350px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}


.mission-middle img {
    width: 300px;


}

.mission-middle {
    display: flex;
    align-items: center;
    justify-content: center;


}



.mission-middle img:hover {
    animation: spin 24s linear infinite;

}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}





.mission-right {
    text-align: left;

}

.mission-left {
    text-align: right;

}


.mission-left,
.mission-right {
    display: flex;
    flex-direction: column;
    padding: 15px 0;
    /* justify-content: space-between; */

}

.mission-left,
.mission-right p {
    font-size: 14px;

}

.mission-right {

    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
}

.mission-left {

    display: flex;
    justify-content: space-between;
}

/* .mission-left h1{
   
} */
.left-01,
.left-02,
.left-03 {

    display: flex;
    flex-direction: row-reverse;
    gap: 10px;

}

.right-01,
.right-02,
.right-03 {

    display: flex;
    flex-direction: row;
    gap: 10px;

}

.left-01 h2,
.left-02 h2,
.left-03 h2,
.right-01 h2,
.right-02 h2,
.right-03 h2 {
    color: transparent;

    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;

}


.left-01 h2,
.right-01 h2 {
    -webkit-text-stroke-color: #FF7D39;
}

.left-01 h3,
.right-01 h3 {
    color: #FF7D39;
}

.left-02 h2,
.right-02 h2 {
    -webkit-text-stroke-color: #20536F;
}

.left-02 h3,
.right-02 h3 {
    color:  #20536F;
}

.left-03 h2,
.right-03 h2 {
    -webkit-text-stroke-color: #FF7D39;
}

.left-03 h3,
.right-03 h3 {
    color: #FF7D39;
}


.mission-head h1 {
    color: #20536F;
    margin-top: 40px;
    margin-bottom: 40px;

}





.title-right {
    display: flex;
    flex-direction: column;
    text-align: left;
}

.number {
    font-size: 50px;
}






/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width:1023px) {



.mission-middle img{
    width: 60%;
}

    .mission-cover {

        align-items: center;

       padding: 0 100px;
    }

    .mission-card {
        display: flex;
        flex-direction: column;

    }

    .left-01,
    .left-02,
    .left-03 {

        display: flex;
        flex-direction: row;
        gap: 10px;


    }

    .mission-left,
    .mission-right {
        text-align: left;
        gap: 15px;
    }

    .left-01,
    .left-02,
    .left-03,
    .right-01,
    .right-02,
    .right-03 {
        width: 100%;
        align-items: center;
    }
    .left-01 p, .left-01 h3{
        padding-left: 10px;
    }

}

/* Responsive For Tablet Screen size 601px to 1023px END */





/* Responsive For Mobile Screen size 1024px to 1920px START */
@media (max-width:767px) {

   

.mission-middle img{
    width: 70%;
}
.mission-head h1{
    margin-top: 15px;
    margin-bottom: 5px;
}

    .mission-cover {

        align-items: center;
       padding: 0 30px;
    }
    .mission-card {
        display: flex;
        flex-direction: column;
    }



    .mission-left,
    .mission-right {
        text-align: left;
        gap: 15px;
    }

    .left-01,
    .left-02,
    .left-03,
    .right-01,
    .right-02,
    .right-03 {

        align-items: center;
    }

}

/* Responsive For Mobile Screen size 1024px to 1920px END */
`, "",{"version":3,"sources":["webpack://./src/Components/MissioncardStyles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;;AAGA;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa,CAAC,kBAAkB;;IAEhC,sBAAsB;;;;AAI1B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,qCAAqC;AACzC;;;AAGA;IACI,YAAY;;;AAGhB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;;AAG3B;;;;AAIA;IAGI,mCAAmC;;AAEvC;;AAeA;IACI;QAEI,yBAAyB;IAC7B;AACJ;;;;;;AAMA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;;AAErB;;;AAGA;;IAEI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,oCAAoC;;AAExC;;AAEA;;IAEI,eAAe;;AAEnB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;GAEG;AACH;;;;IAII,aAAa;IACb,2BAA2B;IAC3B,SAAS;;AAEb;;AAEA;;;;IAII,aAAa;IACb,mBAAmB;IACnB,SAAS;;AAEb;;AAEA;;;;;;IAMI,kBAAkB;;IAElB,8BAA8B;IAC9B,gCAAgC;;AAEpC;;;AAGA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,cAAc;AAClB;;;AAGA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;;AAEvB;;;;;;AAMA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;;;;;AAOA,4DAA4D;AAC5D;;;;AAIA;IACI,UAAU;AACd;;IAEI;;QAEI,mBAAmB;;OAEpB,gBAAgB;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;;IAE1B;;IAEA;;;;QAII,aAAa;QACb,mBAAmB;QACnB,SAAS;;;IAGb;;IAEA;;QAEI,gBAAgB;QAChB,SAAS;IACb;;IAEA;;;;;;QAMI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;;AAEJ;;AAEA,0DAA0D;;;;;;AAM1D,6DAA6D;AAC7D;;;;AAIA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;IAEI;;QAEI,mBAAmB;OACpB,eAAe;IAClB;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;;;;IAIA;;QAEI,gBAAgB;QAChB,SAAS;IACb;;IAEA;;;;;;;QAOI,mBAAmB;IACvB;;AAEJ;;AAEA,2DAA2D","sourcesContent":[".mission-card p{\n    color: #000000;\n}\n\n\n.mission-cover {\n\n    padding: 30px 30px;\n    /* margin-top: 280px; */\n    display: flex;text-align: center;\n\n    flex-direction: column;\n\n\n\n}\n\n.mission-card {\n    max-width: 100%;\n    height: 350px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n}\n\n\n.mission-middle img {\n    width: 300px;\n\n\n}\n\n.mission-middle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n\n}\n\n\n\n.mission-middle img:hover {\n    -webkit-animation: spin 24s linear infinite;\n    -moz-animation: spin 24s linear infinite;\n    animation: spin 24s linear infinite;\n\n}\n\n\n@-moz-keyframes spin {\n    100% {\n        -moz-transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n\n\n\n\n.mission-right {\n    text-align: left;\n\n}\n\n.mission-left {\n    text-align: right;\n\n}\n\n\n.mission-left,\n.mission-right {\n    display: flex;\n    flex-direction: column;\n    padding: 15px 0;\n    /* justify-content: space-between; */\n\n}\n\n.mission-left,\n.mission-right p {\n    font-size: 14px;\n\n}\n\n.mission-right {\n\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: space-between;\n}\n\n.mission-left {\n\n    display: flex;\n    justify-content: space-between;\n}\n\n/* .mission-left h1{\n   \n} */\n.left-01,\n.left-02,\n.left-03 {\n\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 10px;\n\n}\n\n.right-01,\n.right-02,\n.right-03 {\n\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n\n}\n\n.left-01 h2,\n.left-02 h2,\n.left-03 h2,\n.right-01 h2,\n.right-02 h2,\n.right-03 h2 {\n    color: transparent;\n\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: black;\n\n}\n\n\n.left-01 h2,\n.right-01 h2 {\n    -webkit-text-stroke-color: #FF7D39;\n}\n\n.left-01 h3,\n.right-01 h3 {\n    color: #FF7D39;\n}\n\n.left-02 h2,\n.right-02 h2 {\n    -webkit-text-stroke-color: #20536F;\n}\n\n.left-02 h3,\n.right-02 h3 {\n    color:  #20536F;\n}\n\n.left-03 h2,\n.right-03 h2 {\n    -webkit-text-stroke-color: #FF7D39;\n}\n\n.left-03 h3,\n.right-03 h3 {\n    color: #FF7D39;\n}\n\n\n.mission-head h1 {\n    color: #20536F;\n    margin-top: 40px;\n    margin-bottom: 40px;\n\n}\n\n\n\n\n\n.title-right {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n}\n\n.number {\n    font-size: 50px;\n}\n\n\n\n\n\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width:1023px) {\n\n\n\n.mission-middle img{\n    width: 60%;\n}\n\n    .mission-cover {\n\n        align-items: center;\n\n       padding: 0 100px;\n    }\n\n    .mission-card {\n        display: flex;\n        flex-direction: column;\n\n    }\n\n    .left-01,\n    .left-02,\n    .left-03 {\n\n        display: flex;\n        flex-direction: row;\n        gap: 10px;\n\n\n    }\n\n    .mission-left,\n    .mission-right {\n        text-align: left;\n        gap: 15px;\n    }\n\n    .left-01,\n    .left-02,\n    .left-03,\n    .right-01,\n    .right-02,\n    .right-03 {\n        width: 100%;\n        align-items: center;\n    }\n    .left-01 p, .left-01 h3{\n        padding-left: 10px;\n    }\n\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n\n\n\n\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n@media (max-width:767px) {\n\n   \n\n.mission-middle img{\n    width: 70%;\n}\n.mission-head h1{\n    margin-top: 15px;\n    margin-bottom: 5px;\n}\n\n    .mission-cover {\n\n        align-items: center;\n       padding: 0 30px;\n    }\n    .mission-card {\n        display: flex;\n        flex-direction: column;\n    }\n\n\n\n    .mission-left,\n    .mission-right {\n        text-align: left;\n        gap: 15px;\n    }\n\n    .left-01,\n    .left-02,\n    .left-03,\n    .right-01,\n    .right-02,\n    .right-03 {\n\n        align-items: center;\n    }\n\n}\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
